// Description: Font Awesome Icons library 

import { library } from "@fortawesome/fontawesome-svg-core";
import { 
  faRightFromBracket,
  faHouse,
  faBars,
  faCircleInfo,
  faBuildingColumns,
  faScrewdriverWrench,
  faUser,
  faGear,
  faPhone,
  faEnvelope,
  faLocationDot,
  faTrash,
  faUserPlus,
  faCreditCard,

} from "@fortawesome/free-solid-svg-icons";

import { 
  faStripe,
  faCcVisa,
  faCcMastercard,
  faCcDiscover,
  faCcApplePay,
  faCcAmazonPay,
  faCcPaypal,
} from "@fortawesome/free-brands-svg-icons";

library.add(
  // Solid
  faRightFromBracket,
  faHouse,
  faBars,
  faCircleInfo,
  faBuildingColumns,
  faScrewdriverWrench,
  faUser,
  faGear,
  faPhone,
  faEnvelope,
  faLocationDot,
  faTrash,
  faUserPlus,
  faCreditCard,

  // Brands
  faStripe,
  faCcVisa,
  faCcMastercard,
  faCcDiscover,
  faCcApplePay,
  faCcAmazonPay,
  faCcPaypal,
);